export const Brand = () => (
  <span className="brand">
    <span className="brand-icon">
      <svg viewBox="0 0 28 28" aria-hidden="true">
        <path d="M22 6H6v17h16M22 12H12v11" />
      </svg>
    </span>
    calque<span className="version">Early access</span>
  </span>
);
